import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OtherProfessionalPositionInterface } from '../data';
import { OtherProfessionalPositionProvider } from '../providers/other-professional-position.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetOtherProfessionalPositionsUseCase implements UseCase<Observable<Transaction<OtherProfessionalPositionInterface[]>>> {
    constructor(private otherProfessionalPositionProvider: OtherProfessionalPositionProvider) {}

    bind(): Observable<Transaction<OtherProfessionalPositionInterface[]>> {
        return this.otherProfessionalPositionProvider.find();
    }
}
